import { render, staticRenderFns } from "./Check_otp.vue?vue&type=template&id=16e34ac6&scoped=true"
import script from "./Check_otp.vue?vue&type=script&lang=js"
export * from "./Check_otp.vue?vue&type=script&lang=js"
import style0 from "./Check_otp.vue?vue&type=style&index=0&id=16e34ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e34ac6",
  null
  
)

export default component.exports